import _ from "lodash";

import { HttpAdapter } from "../../../main/adapters/HttpAdapter";

export class EmailSESService {
    HttpAdapter = new HttpAdapter();
    baseUrlDataCommunications = `${publicSettings.aws.baseUrls.dataCommunications}/data-communications`;

    async sendBulk(email) {
        if (!_.get(email, "to.length")) return false;

        return await this.HttpAdapter.call(
            `${this.baseUrlDataCommunications}/send-emails`,
            { ...email }
        );
    }
}
